const Mutations = {
  UpsertAccount: `
        mutation UpsertAccount($input: UpsertAccountInput!) {
            upsert_account(input: $input) {
                username ig_username has_password proxy proxy_label has_proxy has_session
                enabled paused ai_paused session_status last_error last_login_at
                known_followers_count followers_seeded replied_threads_count
                conversation_count last_activity_at pending_outbound_count
                sends_last_hour sends_last_day failed_outbound_count
                timezone locale signup_email_string signup_phone_string first_name last_name city country
                login_count_total login_count_today ig_follower_count
            }
        }
    `,
  ImportAccounts: `
        mutation ImportAccounts($input: ImportAccountsInput!) {
            import_accounts(input: $input) {
                username ig_username first_name last_name city country model_id
                proxy_label has_proxy enabled session_status
                signup_email_string signup_phone_string
            }
        }
    `,
  UpsertAccounts: `
        mutation UpsertAccounts($inputs: [UpsertAccountInput!]!) {
            upsert_accounts(inputs: $inputs) {
                username ig_username first_name last_name city country has_password proxy proxy_label has_proxy
                enabled session_status
            }
        }
    `,
  UpdateAccountProfile: `
        mutation UpdateAccountProfile($username: String!, $first_name: String, $last_name: String, $city: String, $country: String) {
            update_account_profile(username: $username, first_name: $first_name, last_name: $last_name, city: $city, country: $country) {
                username first_name last_name city country
            }
        }
    `,
  UpdateAccountAi: `
        mutation UpdateAccountAi($input: UpdateAccountAiInput!) {
            update_account_ai(input: $input) {
                username
                ai {
                    response_mode delay_min_minutes delay_max_minutes provider model
                    has_api_key temperature system_prompt message_rule_prompt
                    welcome_prompt welcome_template welcome_use_ai
                    last_msg_activated last_msg_limit last_msg_prompt final_message_enabled final_message_after_count final_message_idle_hours final_message_template link_pool
                    voice_id has_voice_api_key voice_replies_enabled
                    poll_interval_min_ms poll_interval_max_ms
                    max_threads_per_cycle_min max_threads_per_cycle_max
                    max_threads_per_day_min max_threads_per_day_max
                max_messages_per_thread_per_day
                    min_reply_gap_min_ms min_reply_gap_max_ms
                    followers_enabled followers_follow_back followers_schedule
                    followers_max_per_cycle_min followers_max_per_cycle_max
                    followers_scan_limit_min followers_scan_limit_max
                    quiet_hours_enabled quiet_hours_start quiet_hours_end quiet_hours_tz
                    ignore_keywords blocklist_usernames skip_group_threads
                    media_replies_enabled auto_accept_message_requests
                    browser_mode browser_engine visible_browser ws_wake_enabled
                    ws_wake_delay_min_sec ws_wake_delay_max_sec
                    stories_enabled stories_per_day_min stories_per_day_max
                    posts_enabled posts_per_day_min posts_per_day_max
                    gallery_categories { id label }
                }
            }
        }
    `,
  UploadReplyMedia: `
        mutation UploadReplyMedia($account: String, $category_id: String, $file: Upload!) {
            upload_reply_media(account: $account, category_id: $category_id, file: $file) {
                id account filename mime_type size description category_id created_at media_url
            }
        }
    `,
  UpdateReplyMedia: `
        mutation UpdateReplyMedia($id: String!, $description: String, $category_id: String) {
            update_reply_media(id: $id, description: $description, category_id: $category_id) {
                id description category_id media_url
            }
        }
    `,
  DeleteReplyMedia: `
        mutation DeleteReplyMedia($id: String!) {
            delete_reply_media(id: $id)
        }
    `,
  UploadPublishMedia: `
        mutation UploadPublishMedia($account: String!, $kind: String!, $file: Upload!, $caption: String) {
            upload_publish_media(account: $account, kind: $kind, file: $file, caption: $caption) {
                id account kind relative_path filename mime_type size caption used_at created_at media_url
            }
        }
    `,
  UpdatePublishMedia: `
        mutation UpdatePublishMedia($id: String!, $caption: String) {
            update_publish_media(id: $id, caption: $caption) {
                id caption media_url used_at
            }
        }
    `,
  DeletePublishMedia: `
        mutation DeletePublishMedia($id: String!) {
            delete_publish_media(id: $id)
        }
    `,
  UpsertMediaCategory: `
        mutation UpsertMediaCategory($account: String, $id: String, $label: String!) {
            upsert_media_category(account: $account, id: $id, label: $label) {
                id label
            }
        }
    `,
  DeleteMediaCategory: `
        mutation DeleteMediaCategory($account: String, $id: String!) {
            delete_media_category(account: $account, id: $id)
        }
    `,
  SetAccountFlags: `
        mutation SetAccountFlags($input: AccountFlagsInput!) {
            set_account_flags(input: $input) {
                username ig_username enabled paused ai_paused warmup_enabled session_status
                last_error last_login_at sends_last_hour failed_outbound_count
            }
        }
    `,
  RemoveAccount: `
        mutation RemoveAccount($username: String!) {
            remove_account(username: $username)
        }
    `,
  ClearSession: `
        mutation ClearSession($username: String!) {
            clear_session(username: $username)
        }
    `,
  Start: `
        mutation Start($once: Boolean) {
            start(once: $once) {
                success message running pid started_at status last_exit_code running_count
            }
        }
    `,
  Stop: `
        mutation Stop {
            stop {
                success message running pid started_at status last_exit_code running_count
            }
        }
    `,
  PauseAll: `
        mutation PauseAll($pause: Boolean!) {
            pause_all(pause: $pause) {
                success message running pid started_at status last_exit_code running_count
            }
        }
    `,
  StartAccount: `
        mutation StartAccount($username: String!) {
            start_account(username: $username) {
                username enabled session_status watcher_status
                process_running process_pid
                last_inbox_tick_at last_followers_tick_at last_requests_tick_at
            }
        }
    `,
  BindPhone: `
        mutation BindPhone($phone_id: String!, $username: String) {
            bind_phone(phone_id: $phone_id, username: $username)
        }
    `,
  StopAccount: `
        mutation StopAccount($username: String!) {
            stop_account(username: $username) {
                username enabled session_status watcher_status
                process_running process_pid
            }
        }
    `,
  LoginAccount: `
        mutation LoginAccount($username: String!) {
            login_account(username: $username) {
                username enabled session_status watcher_status
                process_running process_pid has_session
            }
        }
    `,
  SignupAccount: `
        mutation SignupAccount($username: String!) {
            signup_account(username: $username) {
                username enabled session_status watcher_status
                process_running process_pid has_session
            }
        }
    `,
  OpenAccountEmail: `
        mutation OpenAccountEmail($username: String!) {
            open_account_email(username: $username) {
                username enabled session_status watcher_status
                process_running process_pid has_session
            }
        }
    `,
  SubmitChallenge: `
        mutation SubmitChallenge($code: String!, $challenge_id: String) {
            submit_challenge(code: $code, challenge_id: $challenge_id)
        }
    `,
  CancelChallenge: `
        mutation CancelChallenge {
            cancel_challenge
        }
    `,
  SendDm: `
        mutation SendDm($input: SendDmInput!) {
            send_dm(input: $input) {
                success message started_run
                outbound {
                    id account thread_id peer_username text media_path media_name has_media
                    created_at status error sent_at
                }
            }
        }
    `,
  UpdateConfig: `
        mutation UpdateConfig($input: UpdateConfigInput!) {
            update_config(input: $input) {
                max_concurrent_sessions
                rotation_enabled
                rotation_batch_size
                rotation_shift_minutes
                hide_suspended_accounts
                browser_max_width
                browser_max_height
                blocklist_usernames
            }
        }
    `,
  RecalculateViewports: `
        mutation RecalculateViewports {
            recalculate_viewports {
                success
                touched
            }
        }
    `,
  ResetDailyLimits: `
        mutation ResetDailyLimits {
            reset_daily_limits {
                success
                touched
            }
        }
    `,
  SetThreadManual: `
        mutation SetThreadManual($account: String!, $thread_id: String!, $manual: Boolean!) {
            set_thread_manual(account: $account, thread_id: $thread_id, manual: $manual) {
                account thread_id manual_mode ai_prompt
            }
        }
    `,
  SetThreadPrompt: `
        mutation SetThreadPrompt($account: String!, $thread_id: String!, $ai_prompt: String) {
            set_thread_prompt(account: $account, thread_id: $thread_id, ai_prompt: $ai_prompt) {
                account thread_id ai_prompt manual_mode
            }
        }
    `,
  MarkConversationRead: `
        mutation MarkConversationRead($account: String!, $thread_id: String!) {
            mark_conversation_read(account: $account, thread_id: $thread_id) {
                account thread_id unread
            }
        }
    `,
  RetryOutbound: `
        mutation RetryOutbound($id: String!) {
            retry_outbound(id: $id) {
                id account thread_id peer_username text created_at status error sent_at
            }
        }
    `,
  DiscardOutbound: `
        mutation DiscardOutbound($id: String!) {
            discard_outbound(id: $id) {
                id account thread_id peer_username text created_at status error sent_at send_at
            }
        }
    `,
  SendOutboundNow: `
        mutation SendOutboundNow($id: String!) {
            send_outbound_now(id: $id) {
                id account status send_at text error
            }
        }
    `,
  PauseOutbound: `
        mutation PauseOutbound($id: String!) {
            pause_outbound(id: $id) {
                id account status send_at text error
            }
        }
    `,
  EditOutbound: `
        mutation EditOutbound($id: String!, $text: String!) {
            edit_outbound(id: $id, text: $text) {
                id account status send_at text error
            }
        }
    `,
  RescheduleOutbound: `
        mutation RescheduleOutbound($id: String!, $send_at: String!) {
            reschedule_outbound(id: $id, send_at: $send_at) {
                id account status send_at text error
            }
        }
    `,
  CancelOutbound: `
        mutation CancelOutbound($id: String!) {
            cancel_outbound(id: $id) {
                id account status send_at text error sent_at
            }
        }
    `,
  PreviewReply: `
        mutation PreviewReply($input: PreviewReplyInput!) {
            preview_reply(input: $input) {
                success message text
            }
        }
    `,
  CheckProxy: `
        mutation CheckProxy($username: String!, $proxy: String) {
            check_proxy(username: $username, proxy: $proxy) {
                success message latency_ms timezone locale country_code
            }
        }
    `,
  RescanConversation: `
        mutation ClearConversationHistory($account: String!, $thread_id: String!, $mode: String, $clear_all: Boolean) {
            rescan_conversation(account: $account, thread_id: $thread_id, mode: $mode, clear_all: $clear_all) {
                success message deleted started_run
                conversation {
                    account thread_id title peer_username href unread manual_mode ai_prompt
                    updated_at last_message_at last_preview last_from
                    has_failed_outbound is_follower_only avatar_url
                    messages { id from text at source media_name media_url media_kind outbound_id outbound_status send_at }
                }
            }
        }
    `,
  SetFollowerIgnored: `
        mutation SetFollowerIgnored($account: String!, $username: String!, $ignored: Boolean!) {
            set_follower_ignored(account: $account, username: $username, ignored: $ignored) {
                total_known seeded contacts_rescan_status
                followers { username first_seen_at ignored }
            }
        }
    `,
  ClearAccountContacts: `
        mutation ClearAccountContacts($account: String!) {
            clear_account_contacts(account: $account) {
                success message status account
            }
        }
    `,
  CreateModel: `
        mutation CreateModel($id: String!, $label: String) {
            create_model(id: $id, label: $label) {
                id label first_name last_name city country
                system_prompt message_rule_prompt welcome_prompt welcome_template welcome_use_ai
                last_msg_activated last_msg_limit last_msg_prompt final_message_enabled final_message_after_count final_message_idle_hours final_message_template link_pool
                voice_id voice_replies_enabled
                delay_min_minutes delay_max_minutes
                poll_interval_min_ms poll_interval_max_ms
                max_threads_per_cycle_min max_threads_per_cycle_max
                max_threads_per_day_min max_threads_per_day_max
                max_messages_per_thread_per_day
                min_reply_gap_min_ms min_reply_gap_max_ms
                followers_enabled followers_follow_back followers_schedule
                followers_max_per_cycle_min followers_max_per_cycle_max
                followers_scan_limit_min followers_scan_limit_max
                quiet_hours_enabled quiet_hours_start quiet_hours_end quiet_hours_tz
                ignore_keywords blocklist_usernames skip_group_threads
                media_replies_enabled auto_accept_message_requests
                browser_mode browser_engine visible_browser ws_wake_enabled
                ws_wake_delay_min_sec ws_wake_delay_max_sec
                stories_enabled stories_per_day_min stories_per_day_max
                posts_enabled posts_per_day_min posts_per_day_max
                gallery_categories { id label }
                gallery { file category_id description filename mime_type media_url }
                stories { file category_id description filename mime_type media_url }
                posts { file category_id description filename mime_type media_url }
            }
        }
    `,
  SaveModel: `
        mutation SaveModel($input: SaveGirlModelInput!) {
            save_model(input: $input) {
                id label first_name last_name city country
                system_prompt message_rule_prompt welcome_prompt welcome_template welcome_use_ai
                last_msg_activated last_msg_limit last_msg_prompt final_message_enabled final_message_after_count final_message_idle_hours final_message_template link_pool
                voice_id voice_replies_enabled
                delay_min_minutes delay_max_minutes
                poll_interval_min_ms poll_interval_max_ms
                max_threads_per_cycle_min max_threads_per_cycle_max
                max_threads_per_day_min max_threads_per_day_max
                max_messages_per_thread_per_day
                min_reply_gap_min_ms min_reply_gap_max_ms
                followers_enabled followers_follow_back followers_schedule
                followers_max_per_cycle_min followers_max_per_cycle_max
                followers_scan_limit_min followers_scan_limit_max
                quiet_hours_enabled quiet_hours_start quiet_hours_end quiet_hours_tz
                ignore_keywords blocklist_usernames skip_group_threads
                media_replies_enabled auto_accept_message_requests
                browser_mode browser_engine visible_browser ws_wake_enabled
                ws_wake_delay_min_sec ws_wake_delay_max_sec
                stories_enabled stories_per_day_min stories_per_day_max
                posts_enabled posts_per_day_min posts_per_day_max
                gallery_categories { id label }
                gallery { file category_id description filename mime_type media_url }
                stories { file category_id description filename mime_type media_url }
                posts { file category_id description filename mime_type media_url }
            }
        }
    `,
  DeleteModel: `
        mutation DeleteModel($id: String!) {
            delete_model(id: $id)
        }
    `,
  UploadModelMedia: `
        mutation UploadModelMedia($model_id: String!, $category_id: String, $file: Upload!) {
            upload_model_media(model_id: $model_id, category_id: $category_id, file: $file) {
                id
                gallery { file category_id description filename mime_type media_url }
                gallery_categories { id label }
            }
        }
    `,
  UpdateModelMedia: `
        mutation UpdateModelMedia($model_id: String!, $file: String!, $description: String, $category_id: String) {
            update_model_media(model_id: $model_id, file: $file, description: $description, category_id: $category_id) {
                id
                gallery { file category_id description filename mime_type media_url }
            }
        }
    `,
  DeleteModelMedia: `
        mutation DeleteModelMedia($model_id: String!, $file: String!) {
            delete_model_media(model_id: $model_id, file: $file) {
                id
                gallery { file category_id description filename mime_type media_url }
            }
        }
    `,
  UploadModelPublishMedia: `
        mutation UploadModelPublishMedia($model_id: String!, $kind: String!, $file: Upload!, $caption: String) {
            upload_model_publish_media(model_id: $model_id, kind: $kind, file: $file, caption: $caption) {
                id
                stories { file category_id description filename mime_type media_url }
                posts { file category_id description filename mime_type media_url }
            }
        }
    `,
  UpdateModelPublishMedia: `
        mutation UpdateModelPublishMedia($model_id: String!, $kind: String!, $file: String!, $caption: String) {
            update_model_publish_media(model_id: $model_id, kind: $kind, file: $file, caption: $caption) {
                id
                stories { file category_id description filename mime_type media_url }
                posts { file category_id description filename mime_type media_url }
            }
        }
    `,
  DeleteModelPublishMedia: `
        mutation DeleteModelPublishMedia($model_id: String!, $kind: String!, $file: String!) {
            delete_model_publish_media(model_id: $model_id, kind: $kind, file: $file) {
                id
                stories { file category_id description filename mime_type media_url }
                posts { file category_id description filename mime_type media_url }
            }
        }
    `,
  ApplyAccountModel: `
        mutation ApplyAccountModel($username: String!, $model_id: String!) {
            apply_account_model(username: $username, model_id: $model_id) {
                username first_name last_name city country model_id
                ai {
                    system_prompt message_rule_prompt welcome_prompt welcome_template welcome_use_ai
                    last_msg_activated last_msg_limit last_msg_prompt final_message_enabled final_message_after_count final_message_idle_hours final_message_template link_pool
                    voice_id voice_replies_enabled
                    delay_min_minutes delay_max_minutes
                    poll_interval_min_ms poll_interval_max_ms
                    max_threads_per_cycle_min max_threads_per_cycle_max
                    max_threads_per_day_min max_threads_per_day_max
                max_messages_per_thread_per_day
                    min_reply_gap_min_ms min_reply_gap_max_ms
                    followers_enabled followers_follow_back followers_schedule
                    followers_max_per_cycle_min followers_max_per_cycle_max
                    followers_scan_limit_min followers_scan_limit_max
                    quiet_hours_enabled quiet_hours_start quiet_hours_end quiet_hours_tz
                    ignore_keywords blocklist_usernames skip_group_threads
                    media_replies_enabled auto_accept_message_requests
                    browser_mode browser_engine visible_browser ws_wake_enabled
                    ws_wake_delay_min_sec ws_wake_delay_max_sec
                    stories_enabled stories_per_day_min stories_per_day_max
                    posts_enabled posts_per_day_min posts_per_day_max
                    gallery_categories { id label }
                }
            }
        }
    `,
  UploadAccountSource: `
        mutation UploadAccountSource($kind: String!, $file: Upload!) {
            upload_account_source(kind: $kind, file: $file) {
                proxies { id kind filename bytes updated_at }
                emails { id kind filename bytes updated_at }
            }
        }
    `,
  RemoveAccountSource: `
        mutation RemoveAccountSource($kind: String!, $id: String!) {
            remove_account_source(kind: $kind, id: $id) {
                proxies { id kind filename bytes updated_at }
                emails { id kind filename bytes updated_at }
            }
        }
    `,
};

export default Mutations;
